__turbopack_context__.v({
  "divider": "index-module__Ho6nLq__divider",
  "infoModalContainer": "index-module__Ho6nLq__infoModalContainer",
  "infoModalDescription": "index-module__Ho6nLq__infoModalDescription",
  "infoModalTitle": "index-module__Ho6nLq__infoModalTitle",
  "infoText": "index-module__Ho6nLq__infoText",
  "infoTextContainer": "index-module__Ho6nLq__infoTextContainer",
  "pricingModal": "index-module__Ho6nLq__pricingModal",
  "supportText": "index-module__Ho6nLq__supportText",
});
